// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "last-modified-date-module--cds--assistive-text--f7279";
export var cdsHideFeedback = "last-modified-date-module--cds--hide-feedback--d493d";
export var cdsShowFeedback = "last-modified-date-module--cds--show-feedback--e1199";
export var cdsSkeleton = "last-modified-date-module--cds--skeleton--0acd9";
export var cdsVisuallyHidden = "last-modified-date-module--cds--visually-hidden--15ac3";
export var row = "last-modified-date-module--row--f1bec";
export var text = "last-modified-date-module--text--24f26";